import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import AppointmentDetails from '../AppointmentDetails';
import AppointmentApproved from '../AppointmentApproved';
import AppointmentCanceled from '../AppointmentCanceled';
import ConfirmationButtons from '../ConfirmationButtons';
import Map from '../GoogleMap';
import Notes from '../Notes';
import { ErrorHandler } from '../Errors/ErrorHandler';
import buttonsBackground from '../../images/buttons_bg.svg';
import AppointmentExpired from '../AppointmentExpired';
import Main from '../Main';
import StaticMap from '../StaticMap';

const AppointmentStatus = {
    New: 0,
    Confirmed: 2,
    Canceled: 99
}

const getNotes = (appointment) => {
    return appointment?.note?.length ? <Notes appointment={appointment} /> : null;
}

const expiredText = () => {
    return <div>
        <div>מועד תור זה עבר ולא ניתן לאשר כעת את ההגעה.</div>
        <div>יש לפנות למרפאה</div>
    </div>
}

export const Confirmation = () => {
    const [blocking, setBlockingState] = useState(false);
    const [appointment, setAppointment] = useState(null);
    const [error, showError] = useState(false);
    const [status, setStatus] = useState(200);
    const { id } = useParams();

    async function fetchAppointment() {
        return axios.get('/confirmation/get?appointmentGuid=' + id + '&browserWidth=' + window.innerWidth)
            .then(response => {
                setAppointment(response.data);
                setStatus(response.status);
                setBlockingState(false);
            })
            .catch(error => {
                setStatus(error.response.status);
                setBlockingState(false);
            });
    }

    useEffect(() => {
        fetchAppointment();
    }, []);

    let notes = getNotes(appointment);
    let buttonsComponent;
    switch (appointment?.status) {
        case AppointmentStatus.Confirmed:
            buttonsComponent = <AppointmentApproved text={appointment?.appointmentApprovedText} />;
            break;
        case AppointmentStatus.Canceled:
            buttonsComponent = <AppointmentCanceled declinedText={appointment?.appointmentDeclinedText} scheduleAppointmentUrl={appointment?.scheduleAppointmentUrl} cooperation={appointment?.cooperation} />;
            break;
        default:
            buttonsComponent =
                <ConfirmationButtons
                    id={appointment?.id}
                    title={"האם לאשר את התור?"}
                    approveText={"אני אגיע"}
                    disapproveText={"לא אגיע"}
                    onClick={() => setBlockingState(true)}
                    callback={fetchAppointment}
                    onCancelClick={fetchAppointment}
                    error={() => showError(true)}
                    method={"confirmation"}
                    rescheduleText={"שינוי התור"}
                    changeAppointmentUrl={appointment?.changeAppointmentUrl}
                    showSpinnerOnClick={true}
                />;
            break;
    }

    let content;

    if (appointment) {
        if (moment() > moment(`${appointment.date} ${appointment.time}`, "DD/MM/YYYY HH:mm:ss")) {
            content =
                <Main appointment={appointment}>
                    <AppointmentExpired doctorName={appointment.doctorName} expiredText={expiredText} />
                </Main>;
        }
        else {
            content =
                <Main blocking={blocking} appointment={appointment} title={"אישור הגעה לתור"}>
                    <AppointmentDetails error={error} appointment={appointment} />
                    <div className="container">
                        <div id="confirmation_buttons" className="d-flex justify-content-center align-items-center flex-column" style={{ backgroundImage: `url(${buttonsBackground})` }}>
                            {buttonsComponent}
                        </div>
                    </div>
                    {notes}
                    {/*<Map appointmentId={appointment.id} address={appointment.clinicAddress} location={appointment.clinicLocation} />*/}
                    <StaticMap mapSource={appointment.clinicMapUrl} mapUrl={appointment.googleMapsUrl} />
                </Main>;
        }
    } else if (status !== 200) {
        content = <ErrorHandler status={status} />;
    } else {
        content = null;
    }

    return content;
}